import { ConfigProvider } from 'antd'
import { LitElement } from 'lit'
import type { Option } from '../lib/option.no-deps'
import { customElement, property } from 'lit/decorators.js'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { getAntConfig } from '../../app-core/lib/ant-overrides/ant-config'
import {
    ContentLoopSettings,
    type ParameterForFilteringByParent,
    type ContentLoopFilterByParent,
    type ContentLoopSettingsValidationErrors,
    type UnitTypeToLoopOverOption,
    type UnitTypesParents,
} from '../../app-core/lib/flowAuthoring/ContentLoopSettings'

@customElement('zaptic-content-loop-settings')
export class ContentLoopSettingsWrapper extends LitElement {
    @property({ type: Array })
    unitTypesParents: UnitTypesParents = []

    @property({ type: Array })
    parameterOptionsForFilteringByParent: ParameterForFilteringByParent[] = []

    @property({ type: Array })
    unitTypesToLoopOverOptions: UnitTypeToLoopOverOption[] = []

    @property({ type: Number })
    selectedUnitTypeToLoopOver: Option<number> = null

    @property({ type: Array })
    selectedFilters: ContentLoopFilterByParent[] = []

    @property({ type: Number })
    taskSubjectUnitType: Option<number> = null

    @property({ type: Object })
    validationErrors: ContentLoopSettingsValidationErrors = { unitTypeToLoopOverError: null }

    private onUnitTypeToLoopOverChange(unitTypeId: number) {
        this.dispatchEvent(
            new CustomEvent<number>('on-unit-type-to-loop-over-change', {
                detail: unitTypeId,
            })
        )
    }

    private onFilterChange(filter: ContentLoopFilterByParent) {
        this.dispatchEvent(
            new CustomEvent<ContentLoopFilterByParent>('on-filter-change', {
                detail: filter,
            })
        )
    }

    private onFilterCleared(unitTypeId: number) {
        this.dispatchEvent(
            new CustomEvent<number>('on-filter-cleared', {
                detail: unitTypeId,
            })
        )
    }

    public render() {
        const config = getAntConfig()
        return ReactDOM.render(
            <ConfigProvider theme={config.theme} locale={config.locale}>
                <ContentLoopSettings
                    parameterOptionsForFilteringByParent={this.parameterOptionsForFilteringByParent}
                    unitTypesParents={this.unitTypesParents}
                    unitTypesToLoopOverOptions={this.unitTypesToLoopOverOptions}
                    selectedUnitTypeToLoopOver={this.selectedUnitTypeToLoopOver}
                    selectedFilters={this.selectedFilters}
                    taskSubjectUnitType={this.taskSubjectUnitType}
                    validationErrors={this.validationErrors}
                    onUnitTypeToLoopOverChange={this.onUnitTypeToLoopOverChange.bind(this)}
                    onFilterChange={this.onFilterChange.bind(this)}
                    onFilterCleared={this.onFilterCleared.bind(this)}
                />
            </ConfigProvider>,
            this
        )
    }

    public createRenderRoot() {
        return this
    }
}
